import { useState } from "react";

/**
 * TODO: Fix type warnings
 */

/**
 * Use local storage. UseState but saves the value to the browsers local storage.
 *
 * @param key The local storage key
 * @param initialValue Initial value
 */
export const useLocalStorage = <T>(
  key: string,
  initialValue: T,
  disabled: boolean = false,
): [T, (value: T | ((val: T) => T)) => void] => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      // Get from local storage by key
      const item = !disabled && window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      if (!item) return initialValue;

      const parsedItem = JSON.parse(item) as T;
      return parsedItem;
    } catch {
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore: T =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (!disabled) {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch {
      // A more advanced implementation would handle the error case
      console.error("Failed to save to localStorage");
    }
  };

  return [storedValue, setValue];
};
